// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var disabled = "_5l-4";
export var fullWidth = "_5l-3";
export var lined = "_5l-1";
export var selected = "_5l-5";
export var tab = "_5l-2";